import { HttpRequest } from '../../components/HttpRequest';

export const orderDetailsApi = {
  /**
   * Fetch order details by order ID
   * API: GET /api/v1/ecommerce/getzedecommerce-order-byid
   */
  async getOrderById(orderId) {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/v1/ecommerce/getzedecommerce-order-byid?orderId=${orderId}`,
      });

      if (response?.status === 200 || response?.status === 201) {
        return {
          success: true,
          data: response?.response?.data,
          status: response?.status,
        };
      }

      return {
        success: false,
        data: null,
        message: 'Failed to fetch order details',
        status: response?.status,
      };
    } catch (error) {
      console.error('Error fetching order details:', error);
      return {
        success: false,
        data: null,
        error: error.message || 'Failed to fetch order details',
        status: 500,
      };
    }
  },

  /**
   * Fetch customer details by customer ID
   * API: GET /api/get_parentcustomer_data
   */
  async getCustomerDetails(customerId) {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/get_parentcustomer_data?customerId=${customerId}`,
      });

      if (response?.status === 200 || response?.status === 201) {
        return {
          success: true,
          data: response?.response?.data,
          status: response?.status,
        };
      }

      return {
        success: false,
        data: null,
        message: 'Failed to fetch customer details',
        status: response?.status,
      };
    } catch (error) {
      console.error('Error fetching customer details:', error);
      return {
        success: false,
        data: null,
        error: error.message || 'Failed to fetch customer details',
        status: 500,
      };
    }
  },
};
